const EnglishData = require("../Loc/en.json");
const SpanishData = require("../Loc/es.json");


const ValidationTranslateFile = () => {
  let storedLang = null;

  try {
    storedLang = JSON.parse(localStorage.getItem("lang"));
  } catch (e) {
    storedLang = "en";
  }

  switch (storedLang) {
    case "es":
      return SpanishData;
    case "en":
      return EnglishData;
    default:
      return EnglishData;
  }
};

module.exports = ValidationTranslateFile;
